import {
  createContext,
  useContext,
} from 'react';

export type AuthorizationCreationTarget =
  | { type: 'claim' }
  | { type: 'serviceLine'; instanceId: string };

export type OpenAuthorizationCreation = (
  authorizationNumber: string,
  target: AuthorizationCreationTarget,
) => void;

type ContextValues = {
  openAuthorizationCreation: OpenAuthorizationCreation;
};

export const AuthorizationCreationContext = createContext<ContextValues>({
  openAuthorizationCreation: () => {},
});

export function useAuthorizationCreation(): ContextValues {
  return useContext(AuthorizationCreationContext);
}
